export let DemoResponse: any = {
    "success": true,
    "message": "Request Completed Successfully",
    "responseStatusCode": 903,
    "data": [
        {
            "channelName": "X channel",
            "couponCode": "PREMIUM55",
            "discountType": 3,
            "discountValue": 0.0,
            "subscriptionPlan": "1628516995010",
            "couponUsed": 3,
            "discountAmount": 165.00,
            "firstUsedDate": "2025-11-07T11:09:01.1079738",
            "lastUsedDate": "2025-11-10T11:48:54.7269384"
        },
        {
            "channelName": "",
            "couponCode": "20OFF",
            "discountType": 1,
            "discountValue": 20.0,
            "subscriptionPlan": "1628516995007,1628516995008,1628516995009,1628516995010,1628516995011",
            "couponUsed": 0,
            "discountAmount": 0.0
        },
        {
            "channelName": "",
            "couponCode": "METACPM1",
            "discountType": 2,
            "discountValue": 0.0,
            "subscriptionPlan": "1628516995007,1628516995009,1628516995010,1628516995011",
            "couponUsed": 0,
            "discountAmount": 0.0
        },
        {
            "channelName": "",
            "couponCode": "STANDARD25",
            "discountType": 3,
            "discountValue": 0.0,
            "subscriptionPlan": "1628516995009",
            "couponUsed": 0,
            "discountAmount": 0.0
        },
        {
            "channelName": "",
            "couponCode": "ALPD30",
            "discountType": 3,
            "discountValue": 0.0,
            "subscriptionPlan": "1761213115",
            "couponUsed": 0,
            "discountAmount": 0.0
        }
    ],
    "code": "IMS0122903",
    "totalRecords": 5,
    "elapsedTime": "48009",
    "showThisMessage": false
}